export default __webpack_public_path__ + "static/media/icon_sms.f8e1b9b1.svg";